import styled from "styled-components";

const Style = styled.div`
  .conf-column {
    padding: 0 32px;
    border-right: 1px solid var(--base-gray-40);

    &:first-of-type {
      padding-left: 0px;
    }

    &:last-of-type {
      padding-right: 0px;
      border-right: 0;
    }

    label {
      font-size: 14px;
      font-weight: 500;
      color: var(--base-gray-80);
    }

    h2 {
      font-size: 30px;
      font-weight: 600;
      color: var(--base-gray-90);
      margin-bottom: 0;
    }
  }
`;

export default Style;
